module.exports = __webpack_public_path__ + "img/Truck2.c7205431.jpg";